"use client";

import { useEffect } from "react";

const LinkedInPixel = () => {
    useEffect(() => {
        // LinkedIn Partner ID
        (window as any)._linkedin_partner_id = process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID || "123456";

        // Initialize LinkedIn data partner IDs array
        (window as any)._linkedin_data_partner_ids = (window as any)._linkedin_data_partner_ids || [];
        (window as any)._linkedin_data_partner_ids.push((window as any)._linkedin_partner_id);

        // LinkedIn tracking script
        (function (l: any) {
            if (!l) {
                (window as any).lintrk = function (a: any, b: any) {
                    (window as any).lintrk.q.push([a, b]);
                };
                (window as any).lintrk.q = [];
            }

            const s = document.getElementsByTagName("script")[0];
            const b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode?.insertBefore(b, s);
        })((window as any).lintrk);
    }, []);

    return (
        <>
            {/* LinkedIn noscript fallback */}
            <noscript>
                <img
                    height="1"
                    width="1"
                    style={{ display: "none" }}
                    alt=""
                    src={`https://px.ads.linkedin.com/collect/?pid=${process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID || "123456"}&fmt=gif`}
                />
            </noscript>
        </>
    );
};

export default LinkedInPixel;